import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MorningstarButtonComponent } from '@aruba/angular-morningstar';
import { SharedModule } from '@shared/shared.module';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FooterComponent } from './components/footer/footer.component';
import { LayoutComponent } from './components/layout/layout.component';
import { MainMenuComponent } from './components/layout/menus/main-menu/main-menu.component';
import { SettingsMenuComponent } from './components/layout/menus/settings-menu/settings-menu.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RedirectLoginComponent } from './components/redirect-login/redirect-login.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignOutComponent } from './components/sign-out/sign-out.component';
import { UserSuspendedComponent } from './components/user-suspended/user-suspended.component';
import { ApiErrorsInterceptor } from './interceptors/api-errors-interceptor.service';
import { CountryInterceptor } from './interceptors/country-interceptor.service';
import { LanguageInterceptor } from './interceptors/language-interceptor.service';
import { OAuthInterceptor } from './interceptors/oauth-interceptor.service';
import { throwIfAlreadyLoaded } from './module-config';

const EXPORTS_COMPONENTS = [
  ErrorPageComponent,
  NotFoundComponent,
  LayoutComponent,
  SignInComponent,
  RedirectLoginComponent,
  UserSuspendedComponent,
  SignOutComponent,
];
const COMPONENTS = [MainMenuComponent, SettingsMenuComponent, FooterComponent];

@NgModule({
  imports: [RouterModule, SharedModule.forRoot(), MorningstarButtonComponent],
  exports: [...EXPORTS_COMPONENTS],
  declarations: [...EXPORTS_COMPONENTS, ...COMPONENTS],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CountryInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorsInterceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
